export const SET_START = 'SET_START';
export const SET_STEPPER = 'SET_STEPPER';
export const SET_ACTIVE = 'SET_ACTIVE';
export const SET_HIDDEN = 'SET_HIDDEN';

export const SET_DATA_INFORMATION = 'SET_DATA_INFORMATION';